var map = {
	"./adjustments/baseline.svg": 22067,
	"./adjustments/outline.svg": 30255,
	"./archive/baseline.svg": 22286,
	"./archive/outline.svg": 54461,
	"./arrow-down/outline.svg": 98794,
	"./arrow-left/outline.svg": 98729,
	"./arrow-narrow-down/baseline.svg": 43426,
	"./arrow-narrow-down/outline.svg": 5651,
	"./arrow-narrow-left/baseline.svg": 22195,
	"./arrow-narrow-left/outline.svg": 77864,
	"./arrow-narrow-right/baseline.svg": 87957,
	"./arrow-narrow-right/outline.svg": 38062,
	"./arrow-narrow-up/baseline.svg": 39397,
	"./arrow-narrow-up/outline.svg": 11772,
	"./arrow-right/outline.svg": 47975,
	"./arrow-up/outline.svg": 74479,
	"./arrows-expand/outline.svg": 22820,
	"./badge-check/outline.svg": 19355,
	"./ban/outline.svg": 99538,
	"./bell-alt/outline.svg": 33275,
	"./bell/baseline.svg": 37982,
	"./bell/outline.svg": 75220,
	"./book-open/outline.svg": 19828,
	"./bookmark/outline.svg": 91569,
	"./briefcase/baseline.svg": 64843,
	"./briefcase/outline.svg": 727,
	"./calendar/baseline.svg": 82867,
	"./calendar/outline.svg": 31637,
	"./carret-left/outline.svg": 13052,
	"./carret-right/outline.svg": 54909,
	"./cash/baseline.svg": 74635,
	"./cash/outline.svg": 21191,
	"./chart-bar/outline.svg": 13993,
	"./chart-pie/outline.svg": 33037,
	"./chart-square-bar/outline.svg": 55178,
	"./chat-alt-2/outline.svg": 4393,
	"./chat-alt/baseline.svg": 6420,
	"./chat-alt/outline.svg": 38578,
	"./chat/outline.svg": 71930,
	"./check-circle/baseline.svg": 52603,
	"./check-circle/outline.svg": 60951,
	"./check/baseline.svg": 40835,
	"./check/outline.svg": 23107,
	"./chevron-down/baseline.svg": 88148,
	"./chevron-down/outline.svg": 4868,
	"./chevron-left/baseline.svg": 54901,
	"./chevron-left/outline.svg": 40321,
	"./chevron-right/baseline.svg": 87346,
	"./chevron-right/outline.svg": 38425,
	"./chevron-up/baseline.svg": 88326,
	"./chevron-up/outline.svg": 89047,
	"./chip/outline.svg": 20336,
	"./clipboard-check/outline.svg": 52651,
	"./clipboard-copy/outline.svg": 53846,
	"./clipboard-list/outline.svg": 12143,
	"./clipboard/outline.svg": 69418,
	"./clock/baseline.svg": 16456,
	"./clock/outline.svg": 39033,
	"./cloud-download/outline.svg": 36235,
	"./cloud-upload/outline.svg": 1168,
	"./cloud/outline.svg": 38729,
	"./code/outline.svg": 98215,
	"./cog/outline.svg": 55555,
	"./collection/outline.svg": 61768,
	"./contrast/outline.svg": 28624,
	"./credit-card/outline.svg": 31018,
	"./database/baseline.svg": 52921,
	"./database/outline.svg": 55890,
	"./document-add/baseline.svg": 95523,
	"./document-add/outline.svg": 12713,
	"./document-download/baseline.svg": 36237,
	"./document-download/outline.svg": 71730,
	"./document-duplicate/baseline.svg": 5536,
	"./document-duplicate/outline.svg": 29418,
	"./document-search/outline.svg": 17537,
	"./document-text/baseline.svg": 14536,
	"./document-text/outline.svg": 14891,
	"./document/baseline.svg": 18252,
	"./document/outline.svg": 83226,
	"./dots-circle-horizontal/baseline.svg": 80509,
	"./dots-circle-horizontal/outline.svg": 68098,
	"./dots-horizontal/outline.svg": 47999,
	"./dots-vertical/outline.svg": 76643,
	"./download/baseline.svg": 1645,
	"./download/outline.svg": 88370,
	"./drag-handle/outline.svg": 22756,
	"./duplicate/baseline.svg": 88030,
	"./duplicate/outline.svg": 35801,
	"./empty/outline.svg": 81648,
	"./escavador/outline.svg": 22940,
	"./escavai-icon-negativa/baseline.svg": 78525,
	"./escavai-icon/baseline.svg": 52967,
	"./escavai/baseline.svg": 12141,
	"./exclamation-circle/baseline.svg": 30178,
	"./exclamation-circle/outline.svg": 22087,
	"./exclamation/baseline.svg": 29412,
	"./exclamation/outline.svg": 33099,
	"./external-link/outline.svg": 26215,
	"./eye-off/baseline.svg": 3022,
	"./eye-off/outline.svg": 18041,
	"./eye/baseline.svg": 36011,
	"./eye/outline.svg": 47226,
	"./featured-user/outline.svg": 63174,
	"./flag/baseline.svg": 60581,
	"./flag/outline.svg": 46834,
	"./information-circle/baseline.svg": 34210,
	"./information-circle/outline.svg": 85051,
	"./library/baseline.svg": 23009,
	"./library/outline.svg": 50232,
	"./lightning-bolt/outline.svg": 64724,
	"./link/outline.svg": 56347,
	"./location/baseline.svg": 24798,
	"./location/outline.svg": 89312,
	"./lock-open/baseline.svg": 48147,
	"./lock-open/outline.svg": 94066,
	"./lock/baseline.svg": 20857,
	"./lock/outline.svg": 80716,
	"./logout/outline.svg": 80261,
	"./mail/outline.svg": 53343,
	"./marker/baseline.svg": 77737,
	"./marker/outline.svg": 20865,
	"./menu/outline.svg": 54246,
	"./message-alt-2/baseline.svg": 93046,
	"./minus/outline.svg": 1615,
	"./movimentacao/baseline.svg": 77390,
	"./newspaper/baseline.svg": 94839,
	"./newspaper/outline.svg": 64854,
	"./office-building/outline.svg": 35123,
	"./paper-clip/outline.svg": 40824,
	"./paper-plane/baseline.svg": 17607,
	"./pencil-alt/baseline.svg": 33934,
	"./pencil-square/baseline.svg": 453,
	"./pencil/baseline.svg": 95469,
	"./pencil/outline.svg": 21550,
	"./photograph/outline.svg": 90108,
	"./plus-circle/baseline.svg": 48518,
	"./plus-circle/outline.svg": 99531,
	"./plus/baseline.svg": 70897,
	"./plus/outline.svg": 55548,
	"./print/baseline.svg": 34402,
	"./print/outline.svg": 89384,
	"./qrcode/baseline.svg": 37974,
	"./qrcode/outline.svg": 68654,
	"./question-mark-circle/baseline.svg": 4824,
	"./question-mark-circle/outline.svg": 78184,
	"./refresh/baseline.svg": 44901,
	"./refresh/outline.svg": 65754,
	"./scale/baseline.svg": 57553,
	"./scale/outline.svg": 73,
	"./search/baseline.svg": 74062,
	"./search/outline.svg": 20265,
	"./selector/outline.svg": 47541,
	"./share/baseline.svg": 83964,
	"./share/outline.svg": 66979,
	"./shield-check/baseline.svg": 47295,
	"./shield-check/outline.svg": 32530,
	"./social-apple-circle/baseline.svg": 44990,
	"./social-apple-circle/color.svg": 84170,
	"./social-facebook-circle/baseline.svg": 54699,
	"./social-facebook-circle/color.svg": 45179,
	"./social-google-circle/color.svg": 8670,
	"./social-twitter-circle/baseline.svg": 25490,
	"./social-twitter-circle/color.svg": 43805,
	"./social-whatsapp-circle/baseline.svg": 81533,
	"./sparkles/baseline.svg": 4833,
	"./sparkles/outline.svg": 91273,
	"./speakerphone/baseline.svg": 65892,
	"./speakerphone/outline.svg": 67295,
	"./star/baseline.svg": 43561,
	"./star/outline.svg": 8915,
	"./status-online/baseline.svg": 85586,
	"./status-online/outline.svg": 76052,
	"./support/baseline.svg": 6875,
	"./support/outline.svg": 6508,
	"./switch-vertical/outline.svg": 21495,
	"./tag/baseline.svg": 85467,
	"./tag/outline.svg": 92627,
	"./template/baseline.svg": 21383,
	"./template/outline.svg": 40645,
	"./trash/baseline.svg": 15955,
	"./trash/outline.svg": 17190,
	"./trending-down/baseline.svg": 25139,
	"./trending-down/outline.svg": 1691,
	"./trending-up/baseline.svg": 41555,
	"./trending-up/outline.svg": 88038,
	"./upload/baseline.svg": 59629,
	"./upload/outline.svg": 61975,
	"./user-circle/baseline.svg": 87389,
	"./user-circle/outline.svg": 36457,
	"./user-group/baseline.svg": 97510,
	"./user-group/outline.svg": 22727,
	"./user-lawsuits/outline.svg": 53467,
	"./user/outline.svg": 82759,
	"./users/baseline.svg": 20860,
	"./users/outline.svg": 24720,
	"./view-grid/outline.svg": 99602,
	"./x-circle/outline.svg": 47888,
	"./x/outline.svg": 67451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30167;